import { render } from "./Europe.vue?vue&type=template&id=04f6c2dd"
import script from "./Europe.vue?vue&type=script&lang=js"
export * from "./Europe.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\uu7u\\Documents\\repo\\state-of-green-green-together\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__